/**
 * Template IDs for Multi Queue Real Time Table widgets
 */
export const MULTI_QUEUE_DEPRECATED_TEMPLATE_ID = 83
export const MULTI_QUEUE_AS_ROWS_TEMPLATE_ID = 1038
export const MULTI_QUEUE_AS_COLUMNS_TEMPLATE_ID = 1041


